import {
	controlPanelLinks,
	myOrganizationLinks,
	partnerPortalLinks,
	riManagerLinks,
	servicesLinks,
} from '@app/sidebar-layout/config/sidebar.links';
import { SectionRestrictionTypeEnum } from '@app/sidebar-layout/enums/section-restriction-type.enum';
import { SectionChapterEnum } from '@app/sidebar-layout/enums/section-chapter.enum';
import { ISection } from '@app/sidebar-layout/interfaces/i-section';
import { Restrictions } from '@app/sidebar-layout/interfaces/i-section-restriction';
import { SidebarIcons } from './sidebarIcons';

export const CONTROL_PANEL_KEY = 'admin-panel';
export const sidebarSections: ISection[] = [
	{
		name: 'Services',
		permissionKey: '',
		restrictions: [],
		chapters: [
			{
				iconUrl: SidebarIcons.servicesHeader,
				type: SectionChapterEnum.List,
				pages: servicesLinks,
				name: 'Services',
			},
		],
	},
	{
		name: 'My Organization',
		permissionKey: 'my-organization',
		restrictions: [],
		chapters: [
			{
				iconUrl: SidebarIcons.myOrgHeader,
				type: SectionChapterEnum.List,
				pages: myOrganizationLinks,
				name: 'My Organization',
			},
		],
	},
	{
		name: 'Control Panel',
		permissionKey: CONTROL_PANEL_KEY,
		restrictions: [
			Restrictions.find((x) => x.type === SectionRestrictionTypeEnum.OrganizationPicker),
			Restrictions.find((x) => x.type === SectionRestrictionTypeEnum.Notifications),
			Restrictions.find((x) => x.type === SectionRestrictionTypeEnum.AddAccount),
		],
		chapters: [
			{
				iconUrl: SidebarIcons.cpHeader,
				type: SectionChapterEnum.List,
				pages: controlPanelLinks,
				name: 'Control Panel',
			},
		],
		hideAtPresentMode: true,
	},
	{
		name: 'Partner Portal',
		permissionKey: 'partner-portal',
		restrictions: [Restrictions.find((x) => x.type === SectionRestrictionTypeEnum.OrganizationPicker)],
		chapters: [
			{
				iconUrl: SidebarIcons.partnersHeader,
				type: SectionChapterEnum.List,
				pages: partnerPortalLinks,
				name: 'Partner Portal',
			},
		],
		hideAtPresentMode: true,
	},
	{
		name: 'RI Manager',
		permissionKey: 'ri-manager',
		restrictions: [
			// @Todo: find better way to open OrganizationPicker only for "EC2 Listings" page
			// Restrictions.find((x) => x.type === SectionRestrictionTypeEnum.OrganizationPicker),
			Restrictions.find((x) => x.type === SectionRestrictionTypeEnum.Notifications),
			Restrictions.find((x) => x.type === SectionRestrictionTypeEnum.AddAccount),
		],
		chapters: [
			{
				iconUrl: SidebarIcons.riManagerHeader,
				type: SectionChapterEnum.List,
				pages: riManagerLinks,
				name: 'RI Manager',
			},
		],
		hideAtPresentMode: true,
	},
];
